import Cookies from "js-cookie"
import {AuthEnum} from '@/utils/setting'


export let getToken = () => {
  return Cookies.get(AuthEnum.TOKEN)
}
export let setToken = (token) => {
  Cookies.set(AuthEnum.TOKEN,token)
}
export let removeToken = () => {
  Cookies.remove(AuthEnum.TOKEN)
}
export let getRefreshToken = () => {
  return Cookies.get(AuthEnum.REFRESH_TOKEN)
}
export let setRefreshToken = (refreshToken) => {
  Cookies.set(AuthEnum.REFRESH_TOKEN,refreshToken)
}
export let removeRefreshToken = () => {
  Cookies.remove(AuthEnum.REFRESH_TOKEN)
}
export let getWatchInterval = () => {
  return Cookies.get(AuthEnum.WATCH_INTERVAL) - 0 || 0
}
export let setWatchInterval = (crrInterval) => {
  Cookies.set(AuthEnum.WATCH_INTERVAL,crrInterval)
}
export let removeWatchInterval = () => {
  Cookies.remove(AuthEnum.WATCH_INTERVAL)
}
export let getRefreshTime = () => {
  return Cookies.get(AuthEnum.REFRESH_TIME)
}
/**
 *
 * @param {*} crrInterval
 * @param {number} time 时间戳
 */
export let setRefreshTime = (crrInterval,time) => {
  let expires = new Date(new Date() * 1 + time);
  Cookies.set(AuthEnum.REFRESH_TIME,crrInterval,{
    expires
  })
}
export let removeRefreshTime = () => {
  Cookies.remove(AuthEnum.REFRESH_TIME)
}
